import React from 'react';
import { Box } from '@mui/material';

interface ResponsiveKpiGridProps {
  children: React.ReactNode;
  /** Gap in MUI spacing units. Default 1.5 (12px). */
  gap?: number;
}

const ResponsiveKpiGrid: React.FC<ResponsiveKpiGridProps> = ({ children, gap = 1.5 }) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: {
        xs: '1fr',
        sm: 'repeat(2, minmax(0, 1fr))',
        md: 'repeat(3, minmax(0, 1fr))',
        xl: 'repeat(auto-fit, minmax(160px, 1fr))',
      },
      gap,
      width: '100%',
      minWidth: 0,
    }}
  >
    {children}
  </Box>
);

export default ResponsiveKpiGrid;
